import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DialogService, DynamicDialogRef, DynamicDialog, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DynamicFormV2Component } from '../dynamic-form.component';

@Component({
  selector: 'cosmos-formly-dialog',
  imports: [DynamicFormV2Component],
  providers: [DialogService],
  templateUrl: './dialog-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicFormDialog {
  private readonly ref = inject(DynamicDialogRef);
  readonly config = inject(DynamicDialogConfig);

  readonly title: string = this.config.data.dialogTitle ?? '';

  instance: DynamicDialog | undefined;

  onFormSubmit($event: any) {
    this.ref.close($event);
  }

  closeDialog() {
    this.ref.close(undefined);
  }
}
